type ProfileIdInput = number | string | null | undefined;

type UserEditing = {
  id: number | string;
  phone_profile_id?: ProfileIdInput;
};

type SaveValues = {
  phone_profile_id?: ProfileIdInput;
  [key: string]: unknown;
};

type ApplyEditUserSaveArgs = {
  values: SaveValues;
  userEditing: UserEditing;
  onUpdateUser: (userId: UserEditing['id'], values: SaveValues) => Promise<unknown>;
  onAssignPhoneProfile?: (userId: UserEditing['id'], profileId: number | null) => Promise<unknown>;
};

const normalizeProfileId = (value: ProfileIdInput): number | null => {
  if (value === '' || value === null || value === undefined) return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

export const applyEditUserSave = async ({
  values,
  userEditing,
  onUpdateUser,
  onAssignPhoneProfile,
}: ApplyEditUserSaveArgs): Promise<void> => {
  const submittedProfileId = normalizeProfileId(values.phone_profile_id);
  const originalProfileId = normalizeProfileId(userEditing.phone_profile_id);

  // Profile assignment lives on a dedicated PATCH endpoint; the user PUT
  // ignores phone_profile_id today, but stripping it keeps the wire payload
  // honest if the PUT handler ever starts processing extra fields.
  const { phone_profile_id: _strippedProfileId, ...valuesWithoutPhoneProfile } = values;

  await onUpdateUser(userEditing.id, valuesWithoutPhoneProfile);
  if (onAssignPhoneProfile && submittedProfileId !== originalProfileId) {
    await onAssignPhoneProfile(userEditing.id, submittedProfileId);
  }
};
